import {
    AutoHeightContainer,
    PriorityReferralView,
    usePageSearch
} from "@therapprove/common";
import { ReferralHeader } from "./ReferralHeader";
import { useReferralFilters } from "./useReferralFilters";

export const Referrals = () => {
    // State
    const { search, setSearch, debouncedSearch } = usePageSearch();
    const { filters, setFilters } = useReferralFilters();

    return (
        <AutoHeightContainer style={{ gap: "1rem" }}>
            <ReferralHeader
                search={search}
                setSearch={setSearch}
                filters={filters}
                setFilters={setFilters}
            />
            <PriorityReferralView
                search={debouncedSearch}
                archived={filters.archived}
                therapyCategoryIds={filters.therapyCategoryIds}
            />
        </AutoHeightContainer>
    );
};
